import React, { useState, useEffect, useContext } from "react";
import { db } from "../firebase";
import { collection, getDocs, addDoc, deleteDoc, doc } from "firebase/firestore";
import { AuthContext } from "../context/AuthContext";

function AdminPulse() {
  const { user } = useContext(AuthContext);
  const [mode, setMode] = useState("game"); 
  const [items, setItems] = useState([]);
  const  [message,setMessage] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  
  
  const CLOUD_NAME = "ddzz7w9dn";
  const UPLOAD_PRESET = "gamepulse_uploads";

  const [gameData, setGameData] = useState({ 
    title: "", price: "", oldPrice: "", images: [], category: "Action", 
    rating: 4.5, description: "", platform: "PS5", trailerUrl: "", buyLink: "" 
  });
  
  const [articleData, setArticleData] = useState({ 
    title: "", subtitle: "", slug: "", category: "NEWS", readTime: "3", 
    images: [], content: "", affiliateLink: ""  
  });

  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;
    setIsUploading(true);
    const uploadedUrls = [];
    try {
      for (const file of files) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", UPLOAD_PRESET);
        const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, { method: "POST", body: formData });
        const data = await response.json();
        uploadedUrls.push(data.secure_url);
      }
      if (mode === "game") {
        setGameData(prev => ({ ...prev, images: [...prev.images, ...uploadedUrls] }));
      } else {
        setArticleData(prev => ({ ...prev, images: [...prev.images, ...uploadedUrls] }));
      }
      setMessage("Images ajoutées !");
    } catch (error) { setMessage("Erreur upload."); } finally { setIsUploading(false); }
  };

  const fetchData = async () => {
    const colName = mode === "game" ? "games" : "articles";
    const querySnapshot = await getDocs(collection(db, colName));
    setItems(querySnapshot.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  useEffect(() => { fetchData(); }, [mode]);

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      const colName = mode === "game" ? "games" : "articles";
      const data = mode === "game" ? gameData : articleData;
      await addDoc(collection(db, colName), { ...data, createdAt: new Date().toISOString() });
      setMessage("Publié !");
      setGameData({ title: "", price: "", oldPrice: "", images: [], category: "Action", rating: 4.5, description: "", platform: "PS5", trailerUrl: "", buyLink: "" });
      setArticleData({ title: "", subtitle: "", slug: "", category: "NEWS", readTime: "3", images: [], content: "", affiliateLink: "" });
      fetchData();
    } catch (error) { setMessage("Erreur."); }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Supprimer ?")) {
      await deleteDoc(doc(db, mode === "game" ? "games" : "articles", id));
      fetchData();
    }
  };

  if (!user || user.name !== "Mamadou Ly") return <div style={{color: 'white', padding: '100px'}}>Accès réservé.</div>;

  return (
    <div style={{ padding: "100px 20px", color: "white", maxWidth: "1100px", margin: "auto" }}>
      <h1>Panel Contrôle <span style={{color: '#ec008c'}}>HQ</span></h1>
      
      <div style={{ display: "flex", gap: "10px", marginBottom: "30px" }}>
        <button onClick={() => setMode("game")} style={mode === "game" ? styles.btnActive : styles.btnNav}>🎮 JEUX</button>
        <button onClick={() => setMode("article")} style={mode === "article" ? styles.btnActive : styles.btnNav}>📄 ARTICLES</button>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1.2fr 0.8fr", gap: "30px" }}>
        <section style={styles.card}>
          <form onSubmit={handleAdd} style={styles.form}>
            {/* --- TITRE --- */}
            <input type="text" placeholder="Titre" required style={styles.input} value={mode === "game" ? gameData.title : articleData.title}
              onChange={(e) => mode === "game" ? setGameData({...gameData, title: e.target.value}) : setArticleData({...articleData, title: e.target.value})} />

            {mode === "game" ? (
              <>
                {/* --- PRIX --- */}
                <div style={{display: 'flex', gap: '10px'}}>
                  <input type="number" placeholder="Prix Actuel" style={{...styles.input, flex: 1}} value={gameData.price} onChange={(e) => setGameData({...gameData, price: e.target.value})} />
                  <input type="number" placeholder="Prix Barré" style={{...styles.input, flex: 1}} value={gameData.oldPrice} onChange={(e) => setGameData({...gameData, oldPrice: e.target.value})} />
                </div>
                {/* --- PLATEFORME & NOTE --- */}
                <div style={{display: 'flex', gap: '10px'}}>
                  <select style={{...styles.input, flex: 1}} value={gameData.platform} onChange={(e) => setGameData({...gameData, platform: e.target.value})}>
                    <option value="PS5">PS5</option><option value="PC">PC</option><option value="Xbox Series X">Xbox Series X</option><option value="Nintendo Switch">Nintendo Switch</option>
                  </select>
                  <input type="number" step="0.1" placeholder="Note / 5" style={{...styles.input, flex: 1}} value={gameData.rating} onChange={(e) => setGameData({...gameData, rating: e.target.value})} />
                </div>
                {/* --- TRAILER & ACHAT --- */}
                <input type="text" placeholder="Lien YouTube Trailer" style={styles.input} value={gameData.trailerUrl} onChange={(e) => setGameData({...gameData, trailerUrl: e.target.value})} />
                <input type="text" placeholder="Lien d'achat (Amazon...)" style={styles.input} value={gameData.buyLink} onChange={(e) => setGameData({...gameData, buyLink: e.target.value})} />
                <textarea placeholder="Description..." style={styles.input} rows="3" value={gameData.description} onChange={(e) => setGameData({...gameData, description: e.target.value})} />
              </>
            ) : (
              <>
                {/* --- ARTICLES SPECIFIQUE --- */}
                <input type="text" placeholder="Sous-titre" style={styles.input} value={articleData.subtitle} onChange={(e) => setArticleData({...articleData, subtitle: e.target.value})} />
                <div style={{display: 'flex', gap: '10px'}}>
                  <input type="text" placeholder="Slug (ex: gta-6-news)" style={{...styles.input, flex: 1}} value={articleData.slug} onChange={(e) => setArticleData({...articleData, slug: e.target.value})} />
                  <input type="number" placeholder="Min. lecture" style={{...styles.input, flex: 1}} value={articleData.readTime} onChange={(e) => setArticleData({...articleData, readTime: e.target.value})} />
                </div>
                <input type="text" placeholder="Lien d'achat/Affiliation" style={styles.input} value={articleData.affiliateLink} onChange={(e) => setArticleData({...articleData, affiliateLink: e.target.value})} />
                <textarea placeholder="Contenu..." style={styles.input} rows="6" value={articleData.content} onChange={(e) => setArticleData({...articleData, content: e.target.value})} />
              </>
            )}

            {/* --- UPLOAD --- */}
            <div style={styles.uploadBox}>
              <input type="file" accept="image/*" multiple onChange={handleImageUpload} />
              <div style={{ display: 'flex', gap: '5px', marginTop: '10px' }}>
                {(mode === "game" ? gameData.images : articleData.images).map((url, i) => <img key={i} src={url} style={styles.preview} />)}
              </div>
            </div>

            <button type="submit" style={styles.btnSubmit} disabled={isUploading}>{isUploading ? "UPLOAD EN COURS..." : "PUBLIER SUR LE SITE"}</button>
          </form>
        </section>

        {/* --- LISTE --- */}
        <section style={styles.card}>
          <h2>En ligne</h2>
          <div style={{ maxHeight: "500px", overflowY: "auto" }}>
            {items.map(item => (
              <div key={item.id} style={styles.listItem}>
                <span>{item.title}</span>
                <button onClick={() => handleDelete(item.id)} style={styles.btnDelete}>X</button>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}

const styles = {
  card: { background: "#11121a", padding: "20px", borderRadius: "15px", border: "1px solid #222" },
  form: { display: "flex", flexDirection: "column", gap: "10px" },
  input: { padding: "10px", borderRadius: "8px", border: "1px solid #333", background: "#050508", color: "white" },
  uploadBox: { padding: "10px", border: "1px dashed #444", borderRadius: "10px" },
  preview: { width: "40px", height: "40px", objectFit: "cover", borderRadius: "4px" },
  btnNav: { padding: "10px 20px", cursor: "pointer", background: "transparent", color: "#888", border: "none" },
  btnActive: { padding: "10px 20px", cursor: "pointer", background: "#ec008c", color: "white", borderRadius: "8px", fontWeight: "bold" },
  btnSubmit: { background: "linear-gradient(90deg, #ec008c, #fc6767)", color: "white", padding: "12px", border: "none", borderRadius: "10px", fontWeight: "bold", cursor: "pointer" },
  listItem: { display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: "1px solid #222" },
  btnDelete: { background: "red", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", padding: "2px 6px" }
};

export default AdminPulse;